import { actions, services } from '@ehi/global-marketing-interface';
import { gmiRequest } from 'actions/request';

/**
 * getUpcomingTrips
 * gmi service call to get user's upcoming trips
 * @param {bool} loadingOverlay if true, it will show loading overlay on the page
 * @return {Promise}
 */
export const getUpcomingTrips = loadingOverlay => dispatch =>
  dispatch(
    gmiRequest({
      action: actions.request({
        service: services.gma.trips.upcoming,
      }),
      loadingOverlay,
    })
  );

/**
 * getPastTrips
 * gmi service call to get user's past trips
 * @param {bool} loadingOverlay if true, it will show loading overlay on the page
 * @param {object} payload - necessary data (membership_number) to send to GBO
 * @return {Promise}
 */
export const getPastTrips = (payload, loadingOverlay) => dispatch =>
  dispatch(
    gmiRequest({
      action: actions.request({
        data: {
          payload,
        },
        service: services.gma.trips.past,
      }),
      loadingOverlay,
    })
  );

/**
 * getPastTrips
 * gmi service call to get unauthenticated/authenticated user's past trips
 * - For auth users: last_name, driver_license, membership_number.
 * - Unath users: last_name, driver_license.
 *
 * @param {object} payload - necessary data to send to GBO.
 * @return {Promise}
 */
export const getUnauthPastTrips = payload => dispatch =>
  dispatch(
    gmiRequest({
      action: actions.request({
        data: {
          payload,
        },
        service: services.gma.trips.pastRetain,
      }),
      loadingOverlay: true,
    })
  );

/**
 * getCurrentTrips
 * gmi service call to get user's current trips
 * @param {bool} loadingOverlay if true, it will show loading overlay on the page
 * @return {Promise}
 */
export const getCurrentTrips = loadingOverlay => dispatch =>
  dispatch(
    gmiRequest({
      action: actions.request({
        service: services.gma.trips.current,
      }),
      loadingOverlay,
    })
  );

/**
 * getPastTripReceipts
 * gmi service to get the receipt by invoice number
 * @param {number} invoiceNumber - Receipt Invoice number
 * @param {string} lastName - Last name from the logged profile
 * @param {bool} loadingOverlay if true, it will show loading overlay on the page
 * @return {Promise}
 */
export const getPastTripReceipts = (invoiceNumber, lastName, loadingOverlay) => dispatch =>
  dispatch(
    gmiRequest({
      action: actions.request({
        service: services.gma.trips.invoice,
        data: {
          params: {
            invoiceNumber,
            lastName,
          },
        },
      }),
      loadingOverlay,
    })
  );
